query allEventsMapping(
  $first: Int,
  $offset: Int,
  $orderBy: [EventsOrderBy!],
  $condition: EventCondition,
  $filter: EventFilter,
  ) {
  allEvents(
      first: $first,
      offset: $offset,
      orderBy: $orderBy,
      condition: $condition,
      filter: $filter
    ) {
    nodes {
      eventId
      eventType
      source
      mappings: eventMappingsByIntId {
        nodes {
          extId
          extRef
          feed
          mappingId
          mappingType
          sportsLabel
          startsAtUtc
          createdAt
          createdBy
          updatedAt
          updatedBy
          competitorsFlipped
          competitionMapping {
            extRef
          }
        }
      }
      eventName
      sportId
      startsAt
      competition {
        competitionName
      }
    }
    totalCount
  }
}
